export const LCV_MODEL_CONFIG_API_PATH = '/api/lcv-model-config';

export const DEFAULT_MODEL_YEAR = '2027/1';

export const MODEL_POPULATE = {
  category: {
    fields: ['documentId', 'nameTh', 'nameEn', 'title'],
    populate: {
      modelGroup: { fields: ['type'] },
    },
  },
  subCategory: {
    fields: ['documentId', 'nameTh', 'nameEn', 'title'],
  },
  colors: {
    populate: {
      color: {
        fields: ['documentId', 'title', 'nameTh', 'nameEn', 'colorCode'],
      },
      front: { fields: ['url'] },
      rear: { fields: ['url'] },
    },
  },
  defaultColor: {
    populate: {
      color: {
        fields: ['documentId', 'title', 'nameTh', 'nameEn', 'colorCode'],
      },
      front: { fields: ['url'] },
      rear: { fields: ['url'] },
    },
  },
  interior: { fields: ['url'] },
  interior_color: {
    fields: ['nameTh', 'colorCodePrimary', 'colorCodeSecondary'],
  },
} as const;

export const DEFAULT_MODEL_GRADE_POPULATE = {
  populate: {
    defaultModel: {
      fields: ['documentId', 'title', 'name'],
    },
    subCategory: {
      populate: {
        defaultSubModel: {
          fields: ['documentId', 'title', 'name'],
        },
        subCategory: {
          fields: ['documentId', 'nameEn', 'nameTh', 'title'],
        },
      },
    },
  },
} as const;

export const YEAR_LINEUP_POPULATE = {
  fields: ['modelYear', 'active'],
  populate: {
    defaultCompareModels: {
      fields: ['documentId', 'title', 'name'],
    },
    lineupModels: {
      fields: ['label'],
      populate: {
        category: {
          fields: ['documentId', 'nameTh', 'nameEn', 'title'],
          populate: {
            modelGroup: { fields: ['type'] },
          },
        },
        defaultModelGrade: DEFAULT_MODEL_GRADE_POPULATE,
        models: {
          populate: MODEL_POPULATE,
        },
      },
    },
  },
} as const;
